
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uvalue",
      function () {
        return require("private-next-pages/uvalue.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uvalue"])
      });
    }
  